import Model, { attr, hasMany } from "@ember-data/model";
import type ModelRegistry from "@ember-data/types/registries/model";

export type Provider = {
  specialtySourceValue: string;
  specialtySourceLabel: string;
};
export type Procedure = { sourceValue: string; sourceLabel: string };

export default class ConsultationAllowedType extends Model {
  @hasMany("follow-up-reason", {
    async: false,
    inverse: "consultationAllowedTypes"
  })
  declare followUpReasons: Array<ModelRegistry["follow-up-reason"]>;
  @attr() declare procedure: Procedure;
  @attr() declare provider: Provider;
}

declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "consultation-allowed-type": ConsultationAllowedType;
  }
}
